"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateMultipleInfo = exports.validateMultipleSync = exports.validateMultiple = exports.shouldValidate = exports.emptyValueIsArray = exports.isEligible = void 0;
const lodash_1 = require("lodash");
const error_1 = require("../../../error");
const formUtil_1 = require("../../../utils/formUtil");
const isEligible = (component) => {
    // TODO: would be nice if this was type safe
    switch (component.type) {
        case 'hidden':
        case 'address':
            if (!component.multiple) {
                return false;
            }
            return true;
        case 'textarea':
            if (!component.as ||
                component.as !== 'json' ||
                (component.as === 'json' && !component.multiple)) {
                return false;
            }
            return true;
        // TODO: For backwards compatibility, skip multiple validation for select components until we can investigate
        // how this validation might break existing forms
        case 'select':
            return false;
        default:
            return true;
    }
};
exports.isEligible = isEligible;
const isTagsComponent = (component) => {
    return (component === null || component === void 0 ? void 0 : component.type) === 'tags';
};
const emptyValueIsArray = (component) => {
    // TODO: How do we infer the data model of the compoennt given only its JSON? For now, we have to hardcode component types
    switch (component.type) {
        case 'datagrid':
        case 'editgrid':
        case 'tagpad':
        case 'sketchpad':
        case 'datatable':
        case 'dynamicWizard':
        case 'file':
            return true;
        case 'select':
        case 'textfield':
            return !!component.multiple;
        case 'tags':
            return component.storeas !== 'string';
        default:
            return true;
    }
};
exports.emptyValueIsArray = emptyValueIsArray;
const shouldValidate = (context) => {
    const { component } = context;
    if (!(0, exports.isEligible)(component)) {
        return false;
    }
    return true;
};
exports.shouldValidate = shouldValidate;
const validateMultiple = (context) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, exports.validateMultipleSync)(context);
});
exports.validateMultiple = validateMultiple;
const validateMultipleSync = (context) => {
    var _a;
    const { component, value } = context;
    // Skip multiple validation if the component tells us to
    if (!(0, exports.isEligible)(component)) {
        return null;
    }
    const shouldBeMultipleArray = !!component.multiple;
    const isRequired = !!((_a = component.validate) === null || _a === void 0 ? void 0 : _a.required);
    const compModelType = (0, formUtil_1.getModelType)(component);
    const underlyingValueShouldBeArray = ['nestedArray', 'nestedDataArray'].indexOf(compModelType) !== -1 ||
        (isTagsComponent(component) && component.storeas === 'array');
    const valueIsArray = Array.isArray(value);
    if (shouldBeMultipleArray) {
        if (valueIsArray && underlyingValueShouldBeArray) {
            if (value.length === 0) {
                return isRequired ? new error_1.FieldError('array_nonempty', Object.assign(Object.assign({}, context), { setting: true })) : null;
            }
            // TODO: We need to be permissive here for file components, which have an array model type but don't have an underlying array value
            // (in other words, a file component's data object will always be a single array regardless of whether or not multiple is set)
            // In the future, we could consider checking the underlying value's type to determine if it should be an array
            // return Array.isArray(value[0]) ? null : new FieldError('array', { ...context, setting: true });
            return null;
        }
        else if (valueIsArray && !underlyingValueShouldBeArray) {
            if (value.length === 0) {
                return isRequired ? new error_1.FieldError('array_nonempty', Object.assign(Object.assign({}, context), { setting: true })) : null;
            }
            return Array.isArray(value[0]) && compModelType !== 'any'
                ? new error_1.FieldError('nonarray', Object.assign(Object.assign({}, context), { setting: true }))
                : null;
        }
        else {
            const error = new error_1.FieldError('array', Object.assign(Object.assign({}, context), { setting: true }));
            // Null/undefined is ok if this value isn't required; anything else should fail
            return (0, lodash_1.isNil)(value) ? (isRequired ? error : null) : error;
        }
    }
    else {
        const canBeArray = (0, exports.emptyValueIsArray)(component) || underlyingValueShouldBeArray;
        if (!canBeArray && valueIsArray) {
            return new error_1.FieldError('nonarray', Object.assign(Object.assign({}, context), { setting: false }));
        }
        return null;
    }
};
exports.validateMultipleSync = validateMultipleSync;
exports.validateMultipleInfo = {
    name: 'validateMultiple',
    process: exports.validateMultiple,
    fullValue: true,
    processSync: exports.validateMultipleSync,
    shouldProcess: exports.shouldValidate,
};
